export const notificationTypes = {
    INSIGHTS_DATA_UPDATED: 'INSIGHTS_DATA_UPDATED',
} as const;
